import { Box, Flex, FormLabel, Menu, MenuButton, MenuItem, MenuList, Text } from '@chakra-ui/react'
import { MdArrowDropDown } from 'react-icons/md'

export interface NivelAderencia {
  nivel: number
  label: string
  cor: string
}

export const niveisAderencia3: NivelAderencia[] = [
  { nivel: 3, label: 'Aderente', cor: '#A3D943' },
  { nivel: 2, label: 'Aderente com ressalvas', cor: '#F2C94C' },
  { nivel: 1, label: 'Não aderente', cor: '#D64545' }
]

export const niveisAderencia5: NivelAderencia[] = [
  { nivel: 5, label: 'Altamente aderente', cor: '#18743B' },
  { nivel: 4, label: 'Aderente', cor: '#A3D943' },
  { nivel: 3, label: 'Aderente com ressalvas', cor: '#F2C94C' },
  { nivel: 2, label: 'Pouco aderente', cor: '#F2994A' },
  { nivel: 1, label: 'Não aderente', cor: '#D64545' }
]

interface iProps {
  label: string
  niveis: NivelAderencia[]
  value?: number
  original?: number | null
  OnChange: (nivel: number) => void
}

const Opcao: React.FC<{ nivel?: NivelAderencia }> = ({ nivel }) => (
  <Flex align='center' gap='.75rem' minH='1.5rem'>
    {nivel && <Box w='1.5rem' h='1.5rem' borderRadius='4px' bg={nivel.cor} flexShrink={0} />}
    {nivel && <Text fontSize='.875rem' color='var(--Gray1)'>{`${nivel.nivel} · ${nivel.label}`}</Text>}
  </Flex>
)

export const SelectAderencia: React.FC<iProps> = ({ label, niveis, value, original, OnChange }) => {
  const atual = niveis.find(n => n.nivel === value)

  return (
    <Box>
      <Flex align='baseline' gap='.75rem' mb='.25rem'>
        <FormLabel color='var(--Gray1)' fontSize='14px' m='0'>{label}</FormLabel>
        {original != null && original > 0 && (
          <Text fontSize='.75rem' color='var(--Gray3)'>Classificação original: {original}</Text>
        )}
      </Flex>
      <Menu matchWidth>
        <MenuButton
          type='button'
          w='100%'
          h='2.25rem'
          px='.75rem'
          bg='white'
          border='1px solid var(--Gray4)'
          borderRadius='4px'
          textAlign='left'
          color='var(--Gray1)'
          _hover={{ bg: 'white' }}
          _active={{ bg: 'white' }}
          _focus={{ boxShadow: '0 0 0 1px #3182ce' }}
        >
          <Flex align='center' justify='space-between'>
            <Opcao nivel={atual} />
            <MdArrowDropDown color='var(--Gray1)' />
          </Flex>
        </MenuButton>
        <MenuList>
          {niveis.map(n => (
            <MenuItem key={n.nivel} onClick={() => OnChange(n.nivel)}>
              <Opcao nivel={n} />
            </MenuItem>
          ))}
        </MenuList>
      </Menu>
    </Box>
  )
}
